<ng-container *ngIf="feedback; else loading">
  <div class="h-100 d-flex justify-content-center align-items-center flex-column">
    <img src="assets/images/thank-you.png" />
    <section class="d-flex flex-column align-items-center text-center m-3">
      <h3>Mohon maaf anda tidak dapat mengisi survei</h3>
      <p>Anda melakukan transaksi diluar periode survei</p>
    </section>
  </div>
</ng-container>
<ng-template #loading>
  <div class="d-flex align-items-center justify-content-center h-100 w-100">
    <div class="loader"></div>
  </div>
</ng-template>
